import { returnSlideArrayFromXml } from "@/components/SoundslidesPlayer/soundslidesDataXml";
import { returnLowerthirdsArrayFromXml } from "@/components/SoundslidesPlayer/soundslidesDataXml";
import { returnShowMetaDataFromXml } from "@/components/SoundslidesPlayer/soundslidesDataXml";
import { returnTimestampFromXml } from "@/components/SoundslidesPlayer/soundslidesDataXml";

import { returnSlideArrayFromTxt } from "@/components/SoundslidesPlayer/soundslidesDataTxt";
import { returnLowerthirdsArrayFromTxt } from "@/components/SoundslidesPlayer/soundslidesDataTxt";
import { returnShowMetaDataFromTxt } from "@/components/SoundslidesPlayer/soundslidesDataTxt";

import { parseMetaDictIntoDisplaySettings } from "@/models/utils/metaDictParse";

import { returnImageDirectoryFromMeta } from "@/components/SoundslidesPlayer/soundslidesDataXml";

import find from "lodash/find";
import orderBy from "lodash/orderBy";

import filter from "lodash/filter";
import map from "lodash/map";
import uniq from "lodash/uniq";
import sum from "lodash/sum";

const hashCode = s =>
  s.split("").reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0);

export class DirectoryShow {
  constructor(fileList, path) {
    this.fileList = fileList;
    this.path = path;
    this.xmlFile = find(this.fileList, i => {
      return i.webkitRelativePath == `${this.path}soundslide.xml`;
    });
    this.xmlString = null;
    this.txtFile = find(this.fileList, i => {
      return i.webkitRelativePath == `${this.path}soundslide.txt`;
    });
    this.txtString = null;

    this.controlHash = null;

    this.error = false;
    this.errorMessage = null;
    this.slideArray = [];
    this.overlayArray = [];
    this.metaDict = {};
    this.imageDirectory = "";
    this.averageImageSize = 0;
    this.displaySettings = {};
    this.blobsLoaded = false;
    this.audioBlob = null;
    this.audioFileObj = null;
    this.duration = null;
    this.info = {};
    this.duration;

    this.ERROR_MISSING_AUDIO = "Audio file is missing from this show.";
    this.ERROR_MISSING_IMAGE = "An image is missing from this show.";
    this.ERROR_MISSING_CONTROL_FILE =
      "Missing Soundslides control file (xml or txt)";
  }

  returnLargestVersionOfFileInProject(filename) {
    var _files = orderBy(
      filter(this.fileList, f => {
        return f.webkitRelativePath.startsWith(this.path);
      }),
      "size",
      "desc"
    );
    var fileObj = find(_files, f => {
      return f.name == filename;
    });
    return fileObj;
  }

  returnAverageImageSize() {
    var sizes = map(this.slideArray, s => {
      return this.returnLargestVersionOfFileInProject(s.file).size;
    });
    return sum(sizes) / this.slideArray.length;
  }

  extractFilesToBlobs() {
    if (this.xmlFile) {
      this.populateFromXml();
    } else {
      this.populateFromTxt();
    }
    // Images.
    var missingImage = false;
    this.slideArray = map(this.slideArray, s => {
      var fileObj = this.returnLargestVersionOfFileInProject(s.file);
      if (!fileObj) {
        missingImage = true;
      }
      s.fileObj = fileObj;
      s.blob = URL.createObjectURL(fileObj);
      return s;
    });
    // Audio.
    var audioFile = this.returnLargestVersionOfFileInProject("audio_hi.mp3");
    if (!audioFile) {
      if (this.displaySettings.noAudio) {
        // Let it pass. It's cool.
      } else {
        this.error = true;
        this.errorMessage = this.ERROR_MISSING_AUDIO;
      }
    } else {
      this.audioFileObj = audioFile;
      this.audioBlob = URL.createObjectURL(audioFile);
    }

    this.blobsLoaded = true;

    if (missingImage) {
      this.error = true;
      this.errorMessage = this.ERROR_MISSING_IMAGE;
    } else {
      this.averageImageSize = this.returnAverageImageSize();
    }

    return this;
  }

  populateFromXml() {
    // Create and return a show object based on the xml file.
    console.log("populateFromXml");
    this.slideArray = returnSlideArrayFromXml(this.xmlString);
    this.overlayArray = returnLowerthirdsArrayFromXml(this.xmlString);
    this.metaDict = returnShowMetaDataFromXml(this.xmlString);
    this.imageDirectory = returnImageDirectoryFromMeta(this.metaDict);
    this.importMetaDictToDisplaySettings();
    this.populateInfo();
  }

  populateFromTxt() {
    // Create and return a show object based on the xml file.
    console.log("populateFromTxt");
    this.slideArray = returnSlideArrayFromTxt(this.txtString);
    this.overlayArray = returnLowerthirdsArrayFromTxt(this.txtString);
    this.metaDict = returnShowMetaDataFromTxt(this.txtString);
    this.imageDirectory = returnImageDirectoryFromMeta(this.metaDict);
    this.importMetaDictToDisplaySettings();
    this.populateInfo();
  }

  populateInfo() {
    console.log(this.metaDict);
    this.info = {
      duration: this.duration,
      slide_count: this.slideArray.length,
      title: this.metaDict.header_headline
    };

    if (this.xmlString) {
      // Extract timestamp.
      this.info.timestamp = returnTimestampFromXml(this.xmlString);
    } else {
      this.info.timestamp = null;
    }

    if (this.metaDict.custom_size == "true") {
      this.info.width = parseInt(this.metaDict.custom_width, 10);
      this.info.height = parseInt(this.metaDict.custom_height, 10);
    } else {
      this.info.width = 600;
      this.info.height = 450;
    }
  }

  importMetaDictToDisplaySettings() {
    this.displaySettings = parseMetaDictIntoDisplaySettings(
      this.metaDict,
      this.displaySettings
    );
    this.duration = this.displaySettings.duration;
    console.log("displaySettings", this.displaySettings);
  }

  async parseControlFile() {
    var _this = this;
    const temporaryFileReader = new FileReader();

    var inputFile;
    if (this.xmlFile) {
      inputFile = this.xmlFile;
    } else {
      inputFile = this.txtFile;
    }

    return new Promise((resolve, reject) => {
      temporaryFileReader.onerror = () => {
        temporaryFileReader.abort();
        reject(new DOMException("Problem parsing input file."));
      };

      temporaryFileReader.onload = () => {
        if (_this.xmlFile) {
          _this.xmlString = temporaryFileReader.result;
          _this.controlHash = hashCode(_this.xmlString);
        } else {
          _this.txtString = temporaryFileReader.result;
          _this.controlHash = hashCode(_this.txtString);
        }
        resolve(_this);
      };
      temporaryFileReader.readAsText(inputFile);
    });
  }
}

export class DirectoryParser {
  constructor(fileList) {
    this.fileList = fileList;
    this.showPaths = [];
    this.shows = [];
    this.zips = []; // Zips contained within the fileList.
    this.parseList();
  }
  parseList() {
    // Look for soundslide.xml and soundslide.txt files.
    var xmlControlFiles = filter(this.fileList, n => {
      return n.webkitRelativePath.endsWith("soundslide.xml");
    });
    var txtControlFiles = filter(this.fileList, n => {
      return n.webkitRelativePath.endsWith("soundslide.txt");
    });
    // Find the roots of any shows.
    var _showPaths = map(xmlControlFiles, x => {
      return x.webkitRelativePath.split("soundslide.xml")[0];
    });

    _showPaths = _showPaths.concat(
      map(txtControlFiles, x => {
        return x.webkitRelativePath.split("soundslide.txt")[0];
      })
    );
    this.showPaths = uniq(_showPaths);
    this.shows = map(this.showPaths, path => {
      return new DirectoryShow(this.fileList, path);
    });

    this.zips = filter(this.fileList, n => {
      return n.webkitRelativePath.endsWith(".zip");
    });
  }
}
